module.exports = __webpack_public_path__ + "static/media/6_file.49cc4126.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/6_file.svg
// module id = 2174
// module chunks = 0